import { Component } from 'react';

export class AdminErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[admin] render crash', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div className="min-h-screen bg-[#0B0B0C] text-white flex items-center justify-center p-6" data-testid="admin-error-boundary">
        <div className="max-w-md w-full bg-[#111214] border border-zinc-800 rounded-2xl p-6 space-y-4">
          <div className="text-[11px] uppercase tracking-wider text-red-400">Something broke on this screen</div>
          <div className="text-sm text-zinc-300 font-mono break-words" data-testid="admin-error-message">{msg}</div>
          <div className="text-[11px] text-zinc-500">Your data is safe. Reload the page to continue — if it happens again, send this message to support.</div>
          <div className="flex gap-2">
            <button type="button" onClick={() => window.location.reload()} className="flex-1 h-10 text-sm font-semibold bg-white text-black rounded-lg" data-testid="admin-error-reload">Reload</button>
            <a href="/admin" className="flex-1 h-10 text-sm text-zinc-300 border border-zinc-800 rounded-lg flex items-center justify-center">Dashboard</a>
          </div>
        </div>
      </div>
    );
  }
}
